import { DefaultHeaderFrSystm, DefaultHeaderToSystm } from "src/const";
import { API_PATH } from "src/const/api-urls";
import { FR_HEADER, TO_HEADER } from "src/const/const-from-env";
import { BaseResponse } from "src/interface";
import {
  IRequestInitPayment,
  IResponseCreatePaymentId,
} from "src/interface/typePay";
import { createCreDtTm, createMSGID } from "src/utils/helper";
import httpsService from "./httpsService";

export const postInitPayment = (
  data: IRequestInitPayment,
  frSystm: string,
  toSystm: string
) => {
  const msgId = createMSGID(frSystm);
  return httpsService.post<any, BaseResponse<any>>(
    API_PATH.INIT_PAYMENT,
    data,
    {
      headers: {
        frSystm: frSystm,
        toSystm: toSystm,
        creDtTm: createCreDtTm(),
        msgId: msgId,
      },
      params: {
        msgId: msgId,
      },
    }
  );
};

export const getDataInitPayment = (
  id: string) => {
  return httpsService.get<any, BaseResponse<IResponseCreatePaymentId>>(
    API_PATH.CREATE_DATA_INIT_PAYMENT,
    {
      headers: {
        frSystm: DefaultHeaderFrSystm,
        toSystm: DefaultHeaderToSystm,
      },
      params: {
        requestId: id,
        msgId: createMSGID(FR_HEADER),
      },
    }
  );
};
